import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import SearchPage from "@/pages/SearchPage";
import ComparisonPage from "@/pages/ComparisonPage";
import AdminPage from "@/pages/AdminPage";
import BrandPage from "@/pages/BrandPage";
import BrandFooter from "@/components/BrandFooter";
import ScrollToTop from "@/components/ScrollToTop";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/compare/:ean" element={<ComparisonPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/brand/:brandName" element={<BrandPage />} />
          </Routes>
          <BrandFooter />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
